/**
 * One send's people, a page at a time (plan 2026-10-14-002 U0a, over the
 * server's `GET …/sends/:dispatchId/log`) — the `send` source of
 * {@link usePlayLogRows}, which holds the one paging implementation. Callers
 * (the send card, the member panel's test result) are unchanged by the
 * generalisation (plan 2026-10-15-004 §6.4).
 */
import type { RepDispatchStatus } from '../../../dispatch-rep-status';

import { SEND_LOG_PAGE_SIZE, usePlayLogRows, type PlayLogRows } from './usePlayLogRows';

export { SEND_LOG_PAGE_SIZE };
export type SendLogRows = PlayLogRows;

export function useSendLogRows({
  playId,
  dispatchId,
  status,
  enabled,
  live,
}: {
  playId: string;
  dispatchId: string | null;
  status: RepDispatchStatus | 'all';
  /** The card is open (nothing is read for a collapsed card). */
  enabled: boolean;
  /** The send's `summary.live` — keep the loaded pages fresh while it is true. */
  live: boolean;
}): SendLogRows {
  return usePlayLogRows({ playId, source: { kind: 'send', dispatchId, status }, enabled, live });
}
